import { Access } from "../../../access/types.ts";

export const GithubAccesses = {
  team: Access({
    description: "Teams within the GitHub organization",
    label: "GitHub Team",
    maturity: "beta",
    delegation: {},
    generated: {},
    parameters: {
      team: {
        type: "dynamic",
        label: "Team",
        description: "Team name",
      },
      username: {
        type: "generated",
        label: "Username",
        description: "GitHub username",
      },
    },
    render: { locator: "team" } as const,
  }),
};

export type GithubAccesses = typeof GithubAccesses;
export type GithubAccess = GithubAccesses[keyof GithubAccesses];

export type GithubTeamAccess = GithubAccesses["team"];
